export function getCrudErrors(error: any): string[] {
  if (!error) return ['Erro desconhecido'];
  
  if (error.error?.message) {
    return Array.isArray(error.error.message) 
      ? error.error.message 
      : [error.error.message];
  }
  
  if (error.message) {
    return [error.message];
  }
  
  return ['Ocorreu um erro inesperado'];
  }